module.exports = __webpack_public_path__ + "static/media/logo-small1.4f13bfe6.png";